import { Component, Input } from '@angular/core';
import { Severity } from '../admin-table/admin-table.component';

/**
 * PLAN-Pitts-Salud-Flota-FRONT.md §8/§6.3 — badge de estado fuera de tabla,
 * con las mismas severidades (p-tag) que ya usa AdminTableComponent. Evita
 * repetir por tercera vez lo que Repuestos hizo a mano con clases
 * `.status-badge` en SCSS local.
 *
 * El caller resuelve `severity` (igual que admin-table.getSeverity()) —
 * este componente no conoce vocabulario de ningún dominio (salud, pedidos,
 * etc.), solo envuelve p-tag para uso fuera de una tabla.
 */
@Component({
  selector: 'app-status-badge',
  standalone: false,
  templateUrl: './status-badge.component.html',
})
export class StatusBadgeComponent {
  @Input() label = '';
  @Input() severity: Severity = 'secondary';
}
